export const kitchenList: string[] = [
  "Make homemade chocolate truffles",
  "Prepare Christmas cupcakes",
  "Make fruit skewers coated in chocolate",
  "Concoct a spicy pumpkin soup",
  "Decorated ginger and cinnamon biscuits",
  "Spiced mulled wine",
  "White chocolate and cranberry truffles",
  "Christmas shortbread cookies",
  "Christmas sugar cane and spice lemonade",
  "Christmas fruit punch",
  "Individual Christmas puddings",
  "Hot chocolates (optional: peppermint-flavored)",
  "Apple and cinnamon tartlets",
  "Christmas smoothie bowl with red fruits and granola",
  "Cranberry jam Swiss roll",
  "Christmas spiced tea (masalai chai)",
  "Hot apple juice cocktail",
  "Soft gingerbread",
  "Chocolate and mint mousse",
  "Chocolates filled with marzipan",
  "Hot cider punch",
  "Cinnamon star biscuits",
  "Non-alcoholic festive Christmas mocktail",
  "Make s’mores",
  "Host a Christmas crepe night",
];

export const outingsList: string[] = [
  "Participate in a Christmas cookie decorating workshop",
  "Watch a Christmas classic with family (movie or cartoon)",
  "Host a special Christmas board game night",
  "Have a tree decorating session with music and fairy lights",
  "Write letters to Santa Claus and post them",
  "Have a pajama party watching photos or videos of past Christmases",
  "Take a photo with Santa Claus",
  "Prepare a Christmas song playlist and organize a home karaoke session",
  "Go on a night walk to admire the Christmas lights in the neighborhood",
  "Prepare personalized gift packages with original paper and ribbons",
  "Do a Christmas puzzle with family",
  "Buy a Christmas scratch ticket",
  "Organize a 'Secret Santa' gift exchange",
  "Participate in a toy drive",
  "Book or go see a Christmas show",
  "Make Christmas wreaths with branches and natural decorations",
  "Go ice skating in an outdoor or indoor rink",
  "Go to the cinema to watch a movie",
  "Prepare and distribute homemade cookies to neighbors",
  "Have a Christmas storytelling evening around a fire or under a blanket",
  "Organize a themed Christmas meal with traditional dishes",
  "Have a photo session dressed as elves or reindeer",
  "Attend a Christmas mass or carol concert",
  "Visit a Christmas market",
  "Create a scrapbook or a photo album of Christmas celebrations",
];

export const moviesList: string[] = [
  "Frozen",
  "Klaus",
  "Home Alone",
  "The Snowman",
  "Love Actually",
  "The Holiday",
  "Elf",
  "The Nightmare Before Christmas",
  "The Christmas Chronicles",
  "The Grinch",
  "The Muppet Christmas Carol",
  "Beauty and the Beast: The Enchanted Christmas",
  "The Family Stone",
  "Mickey's Christmas Carol",
  "A Christmas Carol",
  "The Book of Life",
  "The Ice Princess",
  "The House of Magic",
  "The Star",
  "Snowtime!",
  "Little Vampire",
  "Santa Claus Is Comin' to Town",
  "Coco",
  "Miracle on 34th Street",
  "Jingle All the Way",
];

export const craftsList: string[] = [
  "Make paper decorations for the Christmas tree",
  "Create personalized greeting cards to send to family and friends",
  "Craft salt dough ornaments to decorate the house",
  "Write the Christmas menu",
  "Make scented candles to create a warm atmosphere",
  "Create a homemade advent calendar with little boxes or pouches",
  "Craft Christmas wreaths with branches, berries, and ribbons",
  "Paint pebbles to make small Christmas characters",
  "Make finger puppets for Christmas storytelling",
  "Make paper stars to hang in the house",
  "Create paper snowflakes for wall decoration",
  "Make reindeer or elf masks for dress-up play",
  "Craft felt Christmas stockings and decorate them",
  "Create origami decorations for the tree or to hang",
  "Make Christmas magnets with magnets and festive images",
  "Create Christmas lanterns with glass jars and LED candles",
  "Create place cards for the festive table",
  "Craft snowmen with socks and rice",
  "Make pine cone wreaths and decorate them",
  "Bake dried oranges in the oven for home decoration",
  "Craft gingerbread men from decorative cardboard",
  "Make felt decorations to hang in the house",
  "Create personalized Christmas ornaments with photos or glitter",
  "Create miniature cardboard villages for a Christmas scene",
  "Make DIY gifts for loved ones (candles, lip balms, etc.)",
];

export const hyggeList: string[] = [
  "Prepare tea or hot chocolate and enjoy it with a good book",
  "Create a cozy corner with cushions, blankets, and candles for a relaxing evening",
  "Take a walk in the forest or park to enjoy the winter nature",
  "Cook a comforting and friendly dish to share with family or friends",
  "Do a meditation or yoga session to relax and refocus",
  "Take a family photo in front of the Christmas tree, with optional props and costumes",
  "Organize an afternoon of board games by the fire or candlelight",
  "Make homemade Christmas decorations to add a personal touch to your interior",
  "Take a relaxing bath with scented bath salts and soft music",
  "Prepare a tasting platter of homemade cookies to share with loved ones",
  "Light scented candles and listen to soothing music to create a warm atmosphere",
  "Create a gratitude list to reflect on the small joys of the season",
  "Make handmade gifts for your loved ones",
  "Watch Christmas 'fails' on YouTube for a laugh",
  "Write letters to friends or family",
  "Have a relaxing painting or coloring session to unleash creativity",
  "Prepare a hearty brunch and enjoy a convivial moment with family",
  "Do a relaxation session with breathing exercises and stretching",
  "Listen to a relaxing podcast or show while doing a manual activity",
  "Organize an indoor picnic with cozy cushions and blankets",
  "Watch a cozy movie or series alone or with family",
  "Take a break in the day to mindfully enjoy a cup of tea or coffee",
  "Create a playlist of soothing music for your relaxation moments",
  "Take a stroll in the neighborhood to admire the Christmas light decorations",
  "Spend quality time with your loved ones, sharing simple but precious moments",
];
